import React from "react";
import axios from "axios";

export async function postCall(url, body) {
  /* let token = localStorage.getItem("accessToken");
  var decoded = JSON.parse(token);
  body.id_company = decoded.id_company;
  body.id_user = decoded.id_user; */

  //console.log("id", decoded.id_user);
  //console.log("id_company", decoded.id_company);

  console.log(url)

  try {
    const { data } = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        /* SecureToken: decoded.token */
      }
    });

    return data;
  } catch (err) {
    console.log("error");
    console.log(err);
  }
}

export async function getCall(url, body) {
  try {
    const { data } = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      }
    });

    return data;
  } catch (err) {
    console.log("error");
    console.log(err);
  }
}

export async function loginCall(url, body) {
  try {
    const { data } = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      }
    });

    return data;
  } catch (err) {
    console.log("error");
    console.log(err);
  }
}